import History from 'Store/history';

// Header tabların active durumunu belirler.
export const getActiveIndexByPath = item => {
  const currentPath = History.location?.pathname;
  const { path, subPaths, index } = item;

  // for exception routes

  const pathMappings = [
    { invalidPath: '/coklu-mac-takibi/undefined', redirectPath: '/coklu-mac-takibi' },
    { invalidPath: '/spor-toto/undefined', redirectPath: '/spor-toto' },
    { invalidPath: '/canli-mac-izle/undefined', redirectPath: '/canli-mac-izle' },
    { invalidPath: '/iddaa/undefined', redirectPath: '/iddaa' },
    { invalidPath: '/yazarlar/undefined', redirectPath: '/yazarlar' },
    { invalidPath: '/sans-oyunlari/undefined', redirectPath: '/sans-oyunlari' },
    { invalidPath: '/canli-skor/undefined', redirectPath: '/canli-skor' }
  ];
  
  pathMappings.forEach(({ invalidPath, redirectPath }) => {
    if (currentPath?.includes(invalidPath)) {
      History.push(redirectPath);
    }
  });
  
  // for iddaa - populer conflicts
  const exceptionalPaths = [
    '/iddaa/populer-bahisler',
    '/iddaa/populer-bahisler/basketbol',
    '/iddaa/populer-bahisler/tenis',
    '/iddaa/sana-ozel-maclar/canli',
    '/iddaa/sana-ozel-maclar/yakinda-baslayacak',
    '/iddaa/trend-olan-maclar/canli',
    '/iddaa/trend-olan-maclar/yakinda-baslayacak'
  ];

  if (exceptionalPaths.some(item => item === currentPath)) return 2; // Active Popüler Bahisler

  if (currentPath?.startsWith(path) || (subPaths || []).some(subPath => currentPath?.startsWith(subPath))) return index;

  return -1;
};
  

export const HEADER_LINKS = [
  {
    path: '/iddaa',
    content: 'İddaa',
    iconName: 'svgNavIddaaFinger',
    subPaths: ['/iddaa', '/canli-iddaa'],
    index: 0
  },
  {
    path: '/tribun/lider-100',
    content: 'Tribün',
    iconName: 'svgNavTribune',
    subPaths: ['/tribun'],
    index: 1
  },
  {
    path: '/iddaa/populer-bahisler',
    content: 'Popüler Bahisler',
    iconName: 'svgNavFire',
    subPaths: ['/iddaa/populer-bahisler', '/iddaa/sana-ozel-maclar/canli', '/iddaa/sana-ozel-maclar/yakinda-baslayacak', '/iddaa/trend-olan-maclar/canli', '/iddaa/trend-olan-maclar/yakinda-baslayacak'],
    index: 2
  },
  {
    path: '/yazarlar',
    content: 'Yazarlar',
    iconName: 'svgNavAuthors',
    subPaths: ['/yazarlar'],
    index: 3,
  },
  {
    path: '/coklu-mac-takibi',
    content: 'Çoklu Maç Takibi',
    iconName: 'svgNavMultipleMatch',
    pathList: [
      '/coklu-mac-takibi'
    ],
    index: 4
  },
  {
    path: '/canli-skor',
    content: 'Canlı Skor',
    iconName: 'svgNavScore',
    subPaths: ['/canli-skor'],
    index: 5
  },
  {
    path: '/spor-toto',
    content: 'Spor Toto',
    iconName: 'svgNavSporToto',
    subPaths: ['/spor-toto'],
    index: 6
  },
  {
    path: '/tjk',
    content: 'At Yarışı',
    iconName: 'svgAgNav',
    subPaths: ['/tjk'],
    visibleKey: 'tjk_main_page_visible_v2',
    badgeNew: true,
    index: 7
  },
  {
    path: '/kazi-kazan',
    content: 'Kazı Kazan',
    iconName: 'svgNavScratchCard',
    subPaths: ['/kazi-kazan'],
    badgeNew: true,
    index: 8
  },
  {
    path: '/sanal-bahis',
    content: 'Sanal Bahis',
    iconName: 'svgNavVirtualGames',
    pathList: [
      '/sanal-bahis',
    ],
    index: 9
  },
  {
    path: '/bas-kazan',
    content: 'BasKazan',
    iconName: 'svgMenuInteractiveGame',
    subPaths: ['/bas-kazan'],
    badgeNew: true,
    index: 10
  },
  {
    path: '/milli-piyango',
    content: 'Sayısal Oyunlar',
    iconName: 'svgNavMP',
    subPaths: ['/milli-piyango'],
    index: 11
  },
  {
    path: '/sans-oyunlari',
    content: 'Şans Oyunları',
    iconName: 'svgNavChanceGames',
    subPaths: ['/sans-oyunlari'],
    index: 12
  },

];
